import { useEffect, useRef, useState } from 'react';

export default function Dropdown({ trigger, children, align = 'right', width = 'w-48' }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const alignmentClasses = {
        left: 'left-0',
        right: 'right-0',
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <div
                onClick={() => setIsOpen(!isOpen)}
                className="cursor-pointer"
                role="button"
                tabIndex={0}
            >
                {trigger}
            </div>

            {isOpen && (
                <div
                    className={`absolute ${alignmentClasses[align]} mt-2 ${width} rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-slate-950 shadow-lg ring-1 ring-black/5 dark:ring-white/5 focus:outline-none z-50 overflow-hidden py-1 transition-all animate-in fade-in zoom-in-95 duration-100 ease-out`}
                >
                    {children}
                </div>
            )}
        </div>
    );
}

export function DropdownItem({ children, onClick, to, className = '', danger = false }) {
    const baseClasses = `block w-full px-4 py-2 text-sm text-left transition-colors cursor-pointer flex items-center gap-2 ${danger
            ? 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20'
            : 'text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-white/5'
        } ${className}`;

    if (to) {
        // If it's a link, we'll let the user render it as a Link/NavLink component by passing it as children,
        // OR we can import Link here. But to keep it generic, let's assume 'children' might contain the Link, 
        // or we handle standard onClick. 
        // Actually, usually DropdownItem is a button or a link.
        // Let's keep it simple: if onClick is present, use button behavior.
        return (
            <div className={baseClasses} onClick={onClick}>
                {children}
            </div>
        );
    }

    return (
        <button
            type="button"
            className={baseClasses}
            onClick={onClick}
        >
            {children}
        </button>
    );
}
